/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import"../../../../../../chunks/vec4f64.js";import"../ScreenSpacePass.glsl.js";import"../../shaderModules/Float4PassUniform.js";import"../../shaderModules/interfaces.js";import"../../shaderModules/ShaderBuilder.js";import"../../shaderModules/Texture2DPassUniform.js";export{T as TextureOnlyPassParameters,b as build}from"../../../../../../chunks/TextureOnly.glsl.js";
